import {merge_xhr_result} from "../../../../theme_ciborius/src/assets/theme_ciborius/js/lib.js"
import {
	parent,
} from '../../../../webui/js/dom/element.js';

const seats = window.seats = {}

const Hammer = window.Hammer || function () {}

const events_handler =
{
	haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel'],
	init: function (options) {
		const instance = options.instance
		let initialScale = 1
		let panned_x = 0
		let panned_y = 0
		let pan_start_time = undefined
		let is_panning = false
		let is_zooming = false

		this.hammer = Hammer(options.svgElement, {
			inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchInput
		})

		this.hammer.get('pinch').set({enable: true})

		this.hammer.on('doubletap', function (ev) {
			instance.zoomIn()
		})

		/*this.hammer.on('panstart panmove', function (ev) {
		 // On pan start reset panned variables
		 if (ev.type === 'panstart') {
		 pannedX = 0
		 pannedY = 0
		 }

		 // Pan only the difference
		 instance.panBy({x: ev.deltaX - pannedX, y: ev.deltaY - pannedY})
		 pannedX = ev.deltaX
		 pannedY = ev.deltaY
		 })*/

		this.hammer.on('panstart', function (ev) {
			pan_start_time = new Date().getTime();
			panned_x = 0
			panned_y = 0
		})

		this.hammer.on('panmove', function (ev) {
			if (is_zooming) {
				return;
			}

			const elapsed = new Date().getTime() - pan_start_time
			if (elapsed > 200 || Math.abs(ev.deltaX) > 10 || Math.abs(ev.deltaY) > 10) {
				is_panning = true
				instance.panBy({x: ev.deltaX - panned_x, y: ev.deltaY - panned_y})
				panned_x = ev.deltaX
				panned_y = ev.deltaY
			}
		})

		this.hammer.on('pinchstart', function (ev)
		{
			is_zooming = true
			initialScale = instance.getZoom()

			const container_rect = options.svgElement.getBoundingClientRect()
			const zoom_x = ev.center.x - container_rect.left
			const zoom_y = ev.center.y - container_rect.top

			instance.zoomAtPoint(initialScale * ev.scale, {x: zoom_x, y: zoom_y});
		})

		this.hammer.on('pinchmove', function (ev) {
			if (is_zooming) {
				const container_rect = options.svgElement.getBoundingClientRect()
				const zoom_x = ev.center.x - container_rect.left
				const zoom_y = ev.center.y - container_rect.top

				instance.zoomAtPoint(initialScale * ev.scale, {x: zoom_x, y: zoom_y});
			}
		})

		this.hammer.on('panend pinchend', function () {
			is_panning = false
			is_zooming = false
			document.body.style.overflow = 'visible';
		})

		/*this.hammer.on('pinchstart pinchmove', function (ev) {

		 const container_rect = options.svgElement.getBoundingClientRect()

		 const left = container_rect.left
		 const top = container_rect.top

		 const zoom_x = ev.center.x - left
		 const zoom_y = ev.center.y - top

		 //const zoom_x =  ev.center.x
		 //const zoom_y = ev.center.y

		 //alert(zoom_y)

		 if (ev.type === 'pinchstart') {
		 initialScale = instance.getZoom();
		 instance.zoomAtPoint(initialScale * ev.scale, {x: zoom_x, y: zoom_y});
		 }

		 instance.zoomAtPoint(initialScale * ev.scale, {x: zoom_x, y: zoom_y});
		 })*/


		/*document.addEventListener('touchmove', function (e) {
		 if (is_panning || is_zooming) {
		 e.preventDefault();
		 }
		 }, {passive: false})*/

		options.svgElement.addEventListener('touchstart', function (e)
		{
			e.preventDefault();
		}, {passive: false, capture: true});

	},
	destroy: function () {
		this.hammer.destroy()
	}
}


function find_seat_node (target)
{
	while (target && target !== document) {
		if (target.id) {
			if(target.id.startsWith('seat-0'))
			{
				return target;
			}
		}
		target = target.parentElement;
	}
	return null;
}

function cancel_seat (seat_node, on_canceled, on_error)
{
	var seat_number = seat_node.id
	var xhr = new XMLHttpRequest()
	xhr.open('POST', '/seat/cancel', true);
	xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
	xhr.onreadystatechange = function () {
		if (xhr.readyState === 4)
		{
			if (xhr.status === 200) {
				on_canceled(xhr)
			}
			else {
				on_error(xhr);
			}
		}
	}

	const cnode = container_node()
	const page_id = cnode.getAttribute('data-page-id');
	const redirect_to = window.location.pathname
	if (page_id) {
		const payload = `seat=${seat_number}&page_id=${page_id}&redirect_to=${redirect_to}`;
		xhr.send(payload);
	}
}

function reserve_seat (seat_node, on_reserved, on_error)
{
	var seat_number = seat_node.id;

	var xhr = new XMLHttpRequest();
	xhr.open('POST', '/seat/reserve', true);
	xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
	xhr.onreadystatechange = function () {
		if (xhr.readyState === 4)
		{
			if (xhr.status === 200) {
				on_reserved(xhr)
			}
			else {
				on_error(xhr)
			}
		}
	}

	const cnode = container_node()
	const page_id = cnode.getAttribute('data-page-id');
	const redirect_to = window.location.href
	if (page_id) {
		const payload = `seat=${seat_number}&page_id=${page_id}&redirect_to=${redirect_to}`;
		xhr.send(payload);
	}
}

function assign_seat (seat_node, on_reserved, on_error)
{
	const seat_number = seat_node.id;
	const seat_id = seat_node.getAttribute('serif:id')
	const table_node = parent(seat_node, (n) => ("" + n.getAttribute('id')).startsWith('T-'))

	if (!table_node) {
		alert("error, table node undefined")
	}
	else {
		const table_id = table_node.id

		var xhr = new XMLHttpRequest();
		xhr.open('POST', '/seat/assign', true);
		xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		xhr.onreadystatechange = function () {
			if (xhr.readyState === 4)
			{
				if (xhr.status === 200) {
					on_reserved(xhr)
				}
				else {
					on_error(xhr)
				}
			}
		}

		const cnode = container_node()
		const product_id = cnode.getAttribute('data-product-id');
		const redirect_to = window.location.href
		if (product_id) {
			const payload = `seat=${seat_number}&product_id=${product_id}&redirect_to=${redirect_to}&table_id=${table_id}&seat_id=${seat_id}`;
			xhr.send(payload);
		}
	}
}

function select_seat (node)
{
	requestAnimationFrame(() => {
		const rects = node.querySelectorAll('rect');
		rects.forEach(rect => {
			rect.classList.add('seat-selected')
		});
	})

	const seat_id = "" + node.getAttribute("id")
	seats[seat_id] = true;
}

function deselect_seat (node)
{
	requestAnimationFrame(() => {
		const rects = node.querySelectorAll('rect');
		rects.forEach(rect => {
			rect.classList.remove('seat-selected')
			rect.classList.add('seat-deselected')
		});
	})

	const seat_id = "" + node.getAttribute("id")
	seats[seat_id] = false;
}

let container = undefined

function container_node ()
{
	if (container) {
		return container
	}

	container = document.getElementById("container")
	return container
}

function toggle_seat (node)
{
	const container = container_node()
	const product_id = container.getAttribute("data-product-id")

	const seat_id = "" + node.getAttribute("id")
	if (!seats[seat_id]) {
		seats[seat_id] = false; // false means 'not selected'
	}

	if (product_id)
	{
		if (seats[seat_id])
		{
			deselect_seat(node);
		}
		else {
			select_seat(node);

			assign_seat(node, (xhr) => {

				merge_xhr_result(xhr)

			}, () => {
				deselect_seat(node)
			})
		}
	}
	else {

		const page_id = container.getAttribute("data-page-id")
		const reserved = page_id === 'UFSE86uR9FBTcHHBpgAiA6'

		if ((seats[seat_id] !== 'reserved') && !reserved)
		{
			// Toggle the seat state
			if (seats[seat_id]) {
				deselect_seat(node);

				cancel_seat(node, (xhr) => {
					merge_xhr_result(xhr)
				}, () => {
					select_seat(node);
				})

			}

			else {
				select_seat(node);

				reserve_seat(node, (xhr) => {

					merge_xhr_result(xhr)

				}, () => {
					deselect_seat(node)
				})
			}
		}
	}
}

window.cancel_seat = cancel_seat
window.reserve_seat = reserve_seat
window.toggle_seat = toggle_seat
window.select_seat = select_seat
window.deselect_seat = deselect_seat

window.svgPanZoom = window.svgPanZoom || function () {}

const c = document.querySelector('#container svg')

window.panZoom = window.svgPanZoom(c, {
	zoomEnabled: true,
	controlIconsEnabled: true,
	fit: 1,
	center: 1,
	minZoom: 0.38,
	maxZoom: 20,
	zoomScaleSensitivity: 0.38,
	customEventsHandler: events_handler
})

//window.panZoom.zoomAtPoint(1.9, {y: 250,x:120})
window.panZoom.zoomIn()
c.style.visibility = 'visible'



const select_handler = function (e)
{
	const seat_node = find_seat_node(e.target)

	if (seat_node) {
		toggle_seat(seat_node)
	}
}

function detect_taps (ms)
{
	let timeout, lastTap = 0, single_tap_timeout;
	let startX = 0, startY = 0;
	const movementThreshold = 10; // Threshold for detecting movement (in pixels)

	function detect_movement (event)
	{
		const endX = event.clientX || event.touches[0]?.clientX;
		const endY = event.clientY || event.touches[0]?.clientY;
		const deltaX = Math.abs(endX - startX);
		const deltaY = Math.abs(endY - startY);


		return deltaX <= movementThreshold && deltaY <= movementThreshold;
	}

	return function (evt)
	{
		const source_event = evt
		if (source_event.type === 'pointerdown') {
			// track the starting position of the pointer
			startX = source_event.clientX || source_event.touches[0]?.clientX;
			startY = source_event.clientY || source_event.touches[0]?.clientY;
			return
		}

		// If it's pointerup, check for movement first
		if (!detect_movement(source_event)) {
			// If there was significant movement, don't consider it a tap
			return
		}

		const now = new Date().getTime();
		const tap_len = now - lastTap;

		if (0 < tap_len && tap_len < ms)
		{ // Double tap detected
			clearTimeout(single_tap_timeout); // Cancel the single tap action
			source_event.preventDefault();
			const double_tap_event = new CustomEvent("doubletap", {
				bubbles: true,
				detail: source_event
			});
			source_event.target.dispatchEvent(double_tap_event);
		}
		else { // potential single tap

			single_tap_timeout = setTimeout(() => {
				const single_tap_event = new CustomEvent("singletap", {
					bubbles: true,
					detail: source_event
				});

				source_event.target.dispatchEvent(single_tap_event)
			}, ms); // wait ms to confirm if it's a single tap
		}

		lastTap = now;
	}
}

const handler = detect_taps(25)
document.addEventListener('pointerdown', handler, {passive: true})
document.addEventListener('pointerup', handler, {passive: true})
document.addEventListener('singletap', select_handler, {passive: true})


